const CLIENT_ID = "586317334554-ehtj1146fksmj81gbdt1itvucnv8lbdc.apps.googleusercontent.com";
export default CLIENT_ID;